import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjectTrajectoryS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.22361 4.74975C8.26872 4.78174 8.29554 4.83376 8.29554 4.88924V5.72392C8.29554 5.91593 8.35479 6.06137 8.44427 6.15727C8.53282 6.25218 8.66323 6.31198 8.83358 6.31198H9.54151C12.4064 6.31198 14.6669 8.75124 14.6669 11.7943V12.1737C14.6669 12.3231 14.62 12.4623 14.5237 12.5655C14.4264 12.6698 14.2913 12.7238 14.1431 12.7238C13.9948 12.7238 13.8598 12.6698 13.7625 12.5655C13.6661 12.4623 13.6192 12.3231 13.6192 12.1737V11.7943C13.6192 9.37401 11.7737 7.41224 9.54151 7.41224H8.83358C7.95085 7.41224 7.2478 6.64234 7.2478 5.72392V4.88924C7.2478 4.83376 7.27463 4.78174 7.31974 4.74975C7.36484 4.71776 7.42261 4.70979 7.47463 4.72837C7.65019 4.7911 7.89316 4.7911 8.06872 4.72837C8.12074 4.70979 8.1785 4.71776 8.22361 4.74975Z"
        fill="currentcolor"
      />
      <path
        d="M5.2637 1.1758C5.35777 1.06942 5.49402 1 5.64767 1C5.80132 1 5.93758 1.06941 6.03164 1.1758L8.14572 3.44176C8.34522 3.6556 8.34522 3.99801 8.14572 4.21185C7.94036 4.43196 7.60259 4.43196 7.39723 4.21185L6.17154 2.8981L6.17154 6.1032C6.17154 7.46116 7.23833 8.58825 8.47941 8.58825H9.18734C11.0612 8.58825 12.5429 10.1928 12.5429 12.1736V14.45C12.5429 14.5994 12.496 14.7385 12.3997 14.8418C12.3024 14.9461 12.1673 15.0001 12.0191 15.0001C11.8708 15.0001 11.7358 14.9461 11.6385 14.8418C11.5421 14.7385 11.4952 14.5994 11.4952 14.45V12.1736C11.4952 10.8156 10.4284 9.68852 9.18734 9.68852H8.47941C6.60558 9.68852 5.1238 8.08394 5.1238 6.1032L5.1238 2.8981L3.89811 4.21185C3.69276 4.43197 3.35499 4.43197 3.14963 4.21185C2.95012 3.99801 2.95012 3.6556 3.14963 3.44176L5.2637 1.1758Z"
        stroke="currentcolor"
        fill="#32B4FF"
      />
    </svg>
  )
}

export const IconGeoObjectTrajectory = createIcon({
  l: IconGeoObjectTrajectoryS,
  m: IconGeoObjectTrajectoryS,
  s: IconGeoObjectTrajectoryS,
  xs: IconGeoObjectTrajectoryS,
  name: 'IconGeoObjectTrajectory',
})
